import { useEffect, useLayoutEffect } from 'react';
import { useGTag } from './useGTag';
/**
 * Creates the global site tag installation script
 * @param {string} measurementId analytics measurment id
 * @returns {null}
 */
export const useGTagScript = (measurementId) => {
	const gtag = useGTag();
	// want this to load as soon as possible
	useLayoutEffect(() => {
		const mountPoint = document.scripts[0] || document.head.firstChild;
		const script = document.createElement('script');

		script.id = measurementId;
		script.async = script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
		mountPoint.parentNode.insertBefore(script, mountPoint);
	}, [measurementId]);

	useEffect(() => {
		gtag('js', new Date());
		gtag('config', measurementId);
	}, [measurementId]);
};
